import { Action } from '@ngrx/store';
import { StaticHosts, StaticHostsConfiguration } from '../models/static-hosts.model';

export enum ActionTypes {
  SET_STATIC_HOSTS_CONFIGURATION = 'SET_STATIC_HOSTS_CONFIGURATION',
  ADD_STATIC_HOST_CONFIGURATION = 'ADD_STATIC_HOST_CONFIGURATION',
  UPDATE_STATIC_HOST_CONFIGURATION = 'UPDATE_STATIC_HOST_CONFIGURATION',
  DELETE_STATIC_HOST_CONFIGURATION = 'DELETE_STATIC_HOST_CONFIGURATION',
  CLEAR_STATIC_HOST_CONFIGURATION = 'CLEAR_STATIC_HOST_CONFIGURATION',
}

export class SetStaticHostsConfiguration implements Action {
  readonly type = ActionTypes.SET_STATIC_HOSTS_CONFIGURATION;
  constructor(public payload: StaticHostsConfiguration) {}
}

export class AddStaticHostConfiguration implements Action {
  readonly type = ActionTypes.ADD_STATIC_HOST_CONFIGURATION;
  constructor(public payload: StaticHosts) {}
}

export class UpdateStaticHostConfiguration implements Action {
  readonly type = ActionTypes.UPDATE_STATIC_HOST_CONFIGURATION;
  constructor(public payload: StaticHosts) {}
}

export class DeleteStaticHostConfiguration implements Action {
  readonly type = ActionTypes.DELETE_STATIC_HOST_CONFIGURATION;
  constructor(public payload: string[]) {}
}

export class ClearStaticHostConfiguration implements Action {
  readonly type = ActionTypes.CLEAR_STATIC_HOST_CONFIGURATION;
}

export type Actions =
  | SetStaticHostsConfiguration
  | AddStaticHostConfiguration
  | UpdateStaticHostConfiguration
  | DeleteStaticHostConfiguration
  | ClearStaticHostConfiguration;
